/**
 * Annotations panel - export, measurement visibility, tree. Has data processing.
 */
import { exportAllAnnotationsAsGeoJSON, exportAllAnnotationsAsKML } from "../project/common";
import { BasePanel } from "./BasePanel";
import type { PanelContainer } from "./BasePanel";

const EXPORT_ANNOTATIONS_DROPDOWN = "#export-annotations-popup-dropdown";

export class AnnotationsPanel extends BasePanel {
    private _container: ReturnType<typeof window.jQuery> | null = null;

    getId(): string {
        return "annotations";
    }

    getContainer(): PanelContainer {
        if (!this._container) {
            this._container = window.jQuery("#construkted-annontations-popup");
        }

        return this._container;
    }

    protected onInit(): void {
        const $ = window.jQuery;
        const measurementTools = window.Construkted.measurementTools;
        const panel = this;

        // Export annotations button: toggle dropdown on click
        $(document).on("click", "#export-annotations-popup-btn", (e: any) => {
            e.stopPropagation();

            const $dropdown = $(EXPORT_ANNOTATIONS_DROPDOWN);

            $dropdown.toggle();
        });

        // Export format menu item click: run handler and hide dropdown
        $(document).on(
            "click",
            `${EXPORT_ANNOTATIONS_DROPDOWN} .menu-item[data-export-format]`,
            function (this: HTMLElement) {
                const format = $(this).data("export-format") as string;

                if (format === "pdf") {
                    panel._exportAnnotationsAsPDF();
                } else if (format === "geojson") {
                    panel._exportAnnotationsAsGeoJSON();
                } else if (format === "kml") {
                    panel._exportAnnotationsAsKML();
                }

                $(EXPORT_ANNOTATIONS_DROPDOWN).hide();
            }
        );

        // Close export dropdown when clicking outside
        $(document).on("click", (e: any) => {
            const $dropdown = $(EXPORT_ANNOTATIONS_DROPDOWN);

            if (
                $dropdown.is(":visible") &&
                !$(e.target).closest("#export-annotations-popup-btn").length &&
                !$(e.target).closest(EXPORT_ANNOTATIONS_DROPDOWN).length
            ) {
                $dropdown.hide();
            }
        });

        $("#show-hide-all-measurement-checkbox").change(function (this: HTMLElement) {
            const checked = (this as HTMLInputElement).checked;

            measurementTools.showHideAllMeasurements(checked);
            $("#annotation-list .form-check-input").each(function (this: HTMLElement) {
                (this as HTMLInputElement).checked = checked;
                window.jQuery(this).trigger("change");
            });
        });
    }

    private _exportAnnotationsAsPDF(): void {
        const project = window.Construkted.project;

        project.exportAnnotationsAsPDF();
    }

    private _exportAnnotationsAsGeoJSON(): void {
        const project = window.Construkted.project;

        exportAllAnnotationsAsGeoJSON(project.annotations);
    }

    private _exportAnnotationsAsKML(): void {
        const project = window.Construkted.project;

        exportAllAnnotationsAsKML(project.annotations);
    }

    hasUnsavedChanges(): boolean {
        const treeContainer = document.querySelector("#annotation-tree-container");
        const treeView = treeContainer
            ? (treeContainer as unknown as { _treeView: { hasUnsavedChanges: () => boolean } })._treeView
            : null;

        return treeView?.hasUnsavedChanges?.() ?? false;
    }

    confirmDiscardChanges(): boolean {
        const treeContainer = document.querySelector("#annotation-tree-container");
        const treeView = treeContainer
            ? (treeContainer as unknown as { _treeView: { confirmDiscardChanges: () => boolean } })._treeView
            : null;

        return treeView?.confirmDiscardChanges?.() ?? true;
    }
}
